import React, {Context, createContext, Dispatch, useReducer} from 'react';
import {BrowserRouter} from "react-router-dom";
import {ApptekstProvider} from "./contexts/ApptekstContext";
import ReactDom from "react-dom"
import {AppState} from "types/domain";
import appReducer, {initiellAppState, AppAction} from "reducers/app-reducer";
import Sidevisning from './pages/Sidevisning';

// Tester universell utforming i applikasjonen
// Les mer https://github.com/dequelabs/axe-core-npm
if (process.env.NODE_ENV !== "production") {
    const axe = require("@axe-core/react");
    axe(React, ReactDom, 1000);
}

export const DispatchContext: Context<Dispatch<AppAction>> = createContext({} as any);
export const StateContext = createContext<AppState>({} as any);

function App() {
    const [state, dispatch] = useReducer(appReducer, initiellAppState);

    return (
        <DispatchContext.Provider value={dispatch}>
            <StateContext.Provider value={state}>
                <ApptekstProvider appnavn={['vadis-kontrollrapport']}>
                    <BrowserRouter>
                        <Sidevisning/>
                    </BrowserRouter>
                </ApptekstProvider>
            </StateContext.Provider>
        </DispatchContext.Provider>
    );
}

export default App;
